export default "__VITE_ASSET__Dw2b2wv7__"